import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';
import { styled } from '@mui/material/styles';

interface Props {}

const StyledTextField = styled(MuiTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'var(--iq-robot-surface, #2d313d)',
    '& fieldset': {
      border: '1px solid transparent',
    },
    '&:hover fieldset': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  '& .MuiFormHelperText-root': {
    fontSize: 'var(--text-subhead-size, 14px)',
    marginLeft: '0px',
  },
  '& input:autofill': {
    WebkitBoxShadow: 'unset !important',
  },
  '& input': {
    boxSizing: 'border-box',
    height: 'inherit',
  },
  caretColor: theme.palette.primary.main,
}));

const TextField: React.FC<Props & TextFieldProps> = React.forwardRef((props, ref) => {
  const { className } = props;
  return <StyledTextField ref={ref} className={className} {...props} />;
});

TextField.displayName = 'TextField';

export default React.memo(TextField);
